/**
 @author xiaoye
 @date 2020/4/22 1:54 下午
 */
import config from '@/assets/js/config'
import axios from '@/assets/libs/ajax'
import qs from 'qs';

let baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;

//获取数据接入简易列表
let token01 = null;
export const GetDataSourceList = async (data) => {
    if (token01) {
        token01.cancel({status: 'cancel'});
    }
    token01 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[3] + "/GetDataSourceList?" + qs.stringify(data),
        method: "get",
        token: token01.token,
    })
};

//获取数据接入简易列表
let token02 = null;
export const GetConnByDataSource = async (data) => {
    if (token02) {
        token02.cancel({status: 'cancel'});
    }
    token02 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[5] + "/GetConnByDataSource?" + qs.stringify(data),
        method: "get",
        token: token02.token,
    })
};

//获取数据准备列表
let token03 = null;
export const GetDataSetList = async (data) => {
    if (token03) {
        token03.cancel({status: 'cancel'});
    }
    token03 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[4] + "/GetDataSetList?" + qs.stringify(data),
        method: "get",
        token: token03.token,
    })
};

//获取数据准备列表
let token04 = null;
export const GetDataViewListByDataSet = async (data) => {
    if (token04) {
        token04.cancel({status: 'cancel'});
    }
    token04 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[5] + "/GetDataViewListByDataSet?" + qs.stringify(data),
        method: "get",
        token: token04.token,
    })
};


//删除多维分析
let token05 = null;
export const RemoveDataView = async (data) => {
    if (token05) {
        token05.cancel({status: 'cancel'});
    }
    token05 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[5] + "/RemoveDataView?" + qs.stringify(data),
        method: "get",
        token: token05.token,
    })
};

//快照校验
let token06 = null;
export const GetSnapShotVerify = async (data) => {
    if (token06) {
        token06.cancel({status: 'cancel'});
    }
    token06 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[7] + "/GetSnapShotVerify?" + qs.stringify(data),
        method: "get",
        token: token06.token,
    })
};
//快照添加
let token07 = null;
export const SetSnapShot = async (data) => {
    if (token07) {
        token07.cancel({status: 'cancel'});
    }
    token07 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[7] + "/SetSnapShot?" + qs.stringify(data),
        method: "get",
        token: token07.token,
    })
};//快照添加
let token08 = null;
export const GetDataViewData = async (data) => {
    if (token08) {
        token08.cancel({status: 'cancel'});
    }
    token08 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[5] + "/GetDataViewData?" + qs.stringify(data),
        method: "get",
        token: token08.token,
    })
};
